import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import { Copy } from 'iconsax-react'

import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from './styles'

type FieldCopyProps = {
  inTable: boolean
  visible: boolean
  text: string
  className?: string
  style?: React.CSSProperties
}

const FieldCopy: React.FC<FieldCopyProps> = ({
  inTable,
  visible,
  text,
  className,
  style
}) => {
  const theme = useTheme()

  const [copied, setCopied] = React.useState(false)
  const [copying, setCopying] = React.useState(false)

  const classes = useStyles()

  // Reset when not showing
  React.useEffect(() => {
    if (visible) {
      return
    }

    setCopied(false)
    setCopying(false)
  }, [visible])

  const handleCopy = React.useCallback(async () => {
    setCopied(false)
    setCopying(true)

    await navigator.clipboard.writeText(text)

    setCopying(false)
    setCopied(true)
  }, [text])

  if (!visible || inTable || !text) {
    return null
  }

  return (
    <div className={clsx(classes.root, className)} style={style}>
      <div className={classes.container}>
        <Tooltip
          arrow
          title={copied ? 'Copied' : copying ? 'Copying' : 'Copy to clipboard'}
          placement='top'
        >
          <div onClick={handleCopy} className={classes.icon}>
            <Copy variant='Bulk' size={theme.size.sm} color='grey' />
          </div>
        </Tooltip>
      </div>
    </div>
  )
}

export default FieldCopy
